import * as React from 'react';
import './coachProfile.module.scss';

import { EventCoachIndexView } from '../../../../types/events';
import { MarkdownText } from '../../../../../mainv2/containers/common/text/MarkdownText';

type Props = {
  coach: EventCoachIndexView;
};

export class CoachProfile extends React.Component<Props> {
  render() {
    const { coach } = this.props;
    return (
      <div styleName="container">
        <div styleName="header">
          <img styleName="profile-image" src={coach.profile_photo_url} />
          <div styleName="details-container">
            <div styleName="name">{coach.name}</div>
            <div styleName="title">{coach.title}</div>
          </div>
        </div>
        <div styleName="description">
          <MarkdownText source={coach.profile} />
        </div>
      </div>
    );
  }
}
